export function normalizeFinding(value) {
  const result = { ...value };
  delete result.theme; // Theme is historical data, never an editable input.
  if (result.deficiencyExists === false) {
    for (const key of [
      "rootCause",
      "isSevere",
      "isPervasive",
      "remediationActionPlan",
      "remedialActionsEffective",
      "remedialActionsDate",
      "remedialActionsComments",
      "findingResolved",
      "findingResolvedDate",
      "findingResolutionComments",
      "severity",
      "recommendation",
      "responseDueDate",
      "responseFrom",
      "approvalBy",
      "resolutionNotes",
      "ownerUserId",
    ])
      result[key] = null;
    result.evidenceIds = [];
    result.managementResponseRequired = "no";
    result.closureApprovalRequired = "no";
    result.remediationRequired = "No";
  } else {
    if (result.isSevere !== true) result.severity = null;
    if (result.remedialActionsEffective !== true)
      result.remedialActionsDate = null;
    if (result.findingResolved !== true) result.findingResolvedDate = null;
  }
  return result;
}

const validDate = (value) => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || "")) return false;
  const date = new Date(`${value}T00:00:00Z`);
  return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value;
};

export function validateFinding(value, required = new Set()) {
  const errors = validateFindingDetails(value, required);
  if (value.deficiencyExists === true) {
    if (required.has("recommendation") && !value.recommendation?.trim())
      errors.recommendation = "Recommendation is required.";
    if (value.managementResponseRequired === "yes") {
      if (!value.responseFrom?.trim()) errors.responseFrom = "Select who needs to respond.";
      if (!validDate(value.responseDueDate)) errors.responseDueDate = "Enter a valid response due date.";
    }
    if (value.closureApprovalRequired === "yes" && !value.approvalBy?.trim())
      errors.approvalBy = "Select who must approve closure.";
  }
  return errors;
}

export function validateFindingDetails(value, required = new Set()) {
  const errors = {};
  for (const [key, label] of [
    ["title", "Title"],
    ["category", "Category"],
    ["description", "Description"],
  ]) {
    if (!value[key]?.trim()) errors[key] = `${label} is required.`;
  }
  if (value.deficiencyExists == null)
    errors.deficiencyExists = "Select Yes or No.";
  if (value.deficiencyExists === true) {
    for (const key of ["rootCause", "remediationActionPlan"])
      if (!value[key]?.trim()) errors[key] = "This field is required.";
    for (const key of [
      "isSevere",
      "isPervasive",
      "remedialActionsEffective",
      "findingResolved",
    ])
      if (value[key] == null) errors[key] = "Select Yes or No.";
    if (value.isSevere === true && !value.severity)
      errors.severity = "Severity is required.";
    if (value.remedialActionsEffective === true && !validDate(value.remedialActionsDate))
      errors.remedialActionsDate = "Enter the action date.";
    if (
      value.findingResolved === true &&
      !validDate(
        value.findingResolvedDate ||
        (value.remedialActionsEffective === true && value.remedialActionsDate)
      )
    )
      errors.findingResolvedDate = "Enter the resolution date.";
    if (required.has("supportingevidence") && !value.evidenceIds?.length)
      errors.evidence = "Supporting evidence is required.";
  }
  return errors;
}
